import React, { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

import { getReportBySlug } from 'api/reports';
import { Report } from 'graphql-api';
import { reportCurrentStepPath } from 'utils/path';
import { NOT_FOUND_PATH } from 'constants/paths';

function withReport(WrappedComponent: Function | null = null): Function {
  return function WithReport(): JSX.Element {
    const { reportSlug } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [report, setReport] = useState<Report | null | undefined>(null);

    useEffect(() => {
      void (async () => {
        const currentReport = await getReportBySlug(reportSlug ?? '');
        if (currentReport == null) {
          navigate(NOT_FOUND_PATH);
        } else {
          let navigateState = {};
          const pathname = location.pathname.replace(/\/$/g, '');
          if (new URLSearchParams(location.search).get('paymentSuccess') === 'true') {
            if (currentReport.paid === false) {
              navigateState = { state: { paymentFail: true } };
            }
          }
          const navigatePath = reportCurrentStepPath(currentReport);
          if (navigatePath !== pathname) {
            navigate(navigatePath, navigateState);
          }
        }

        setReport(currentReport);
      })();
    }, []);

    return (
      <>
        {report != null && WrappedComponent != null && (
          <WrappedComponent report={report} setReport={setReport} />
        )}
      </>
    );
  };
}

export default withReport;
